import { ServerDate } from "@/helpers/server-date.class"
import { TAGS, api } from "@/store/api.ts"
import { IServerTimeResponse } from "."

const serverTimeAPI = api.enhanceEndpoints({ addTagTypes: [TAGS.SERVER_TIME] })

export const serverTimeEndpoints = serverTimeAPI.injectEndpoints({
  endpoints: (builder) => ({
    fetchServerTime: builder.query<IServerTimeResponse, void>({
      query: () => ({
        url: "/time",
        method: "GET"
      }),
      providesTags: (result) => [
        { type: TAGS.SERVER_TIME, id: result?.timestamp }
      ],
      transformResponse: (response: IServerTimeResponse) => {
        const currentServerTime = response.timestamp
        const clientTime = new Date()

        const gapMs = currentServerTime - clientTime.getTime()
        ServerDate.setGap(gapMs)

        return { ...response, gapMs }
      }
    })
  })
})

export const {
  useFetchServerTimeQuery,
  endpoints: { fetchServerTime }
} = serverTimeEndpoints
